import React from 'react';
import Navbar from '../components/Navbar';
import Img from '../components/Img';
import Card from '../components/Work';
import Footer from '../components/Footer';
const Home = () => {

  return (
    <div>
    <Navbar />
    <Img />
    <Card/>
    <Footer />
    </div>
  )

}

export default Home;